import Block from "base/Block";

class Text extends Block {
	static get blockName() {
		return 'b-text';
	}

	onInit() {
		let mobileHiddenText = this.el.querySelector('.l-text--mobile-hidden');

		if (mobileHiddenText && window.innerWidth < 430) {
			mobileHiddenText.style.maxHeight = 0;

			let mobileHiddenTextButton = this.el.querySelector('.l-button--hidden-text');
			mobileHiddenTextButton.classList.remove('hidden');

			mobileHiddenTextButton.addEventListener('click', () => {
				mobileHiddenText.style.maxHeight = mobileHiddenText.scrollHeight + 'px';
				mobileHiddenTextButton.classList.add('hidden');
			})
		}
	}
}

Block.register(Text);

export default Text;
